'use client'

import StickyFooter from '@/components/shared/StickyFooter'
import { GrCatalog } from 'react-icons/gr'
import { PiShoppingCartSimpleDuotone } from 'react-icons/pi'
import { TbTruckDelivery } from "react-icons/tb"
import DrawerFilter from '../../(public-pages)/catalog/components/DrawerFilter'
import Link from 'next/link'
import { Badge } from '@/components/ui'
import { useCartStore } from '@/store/useCartStore'
import FooterVTwo from '@/components/template/FooterVTwo'
import { usePathname } from 'next/navigation'

export const CatalogFooter = () => {
    const { countItems } = useCartStore()
    const pathname = usePathname()

    const isCatalogPage = pathname !== '/catalog' &&
    pathname.startsWith('/catalog/')
    return (
        <>
            <div className="hidden lg:block">
                <FooterVTwo />
            </div>

            <StickyFooter className="block lg:hidden bg-white py-[4px] px-[16px] border-t border-gray-200 z-90">
                <div className="flex justify-between items-center">
                    <Link
                        href="/delivery"
                        className="flex flex-col items-center justify-center cursor-pointer rounded-md hover:bg-gray-200 px-3 py-1"
                    >
                        <div className="w-[34px] h-[34px] flex justify-center items-center">
                            <TbTruckDelivery size={24} />
                        </div>

                        <span className="text-[10px] leading-[14px] tracking-[0.02px] text-center">
                            Доставка
                        </span>
                    </Link>

                    <Link
                        href="/catalog"
                        className="flex flex-col items-center justify-center cursor-pointer rounded-md hover:bg-gray-200 px-3 py-1"
                    >
                        <div className="w-[34px] h-[34px] flex justify-center items-center">
                            <GrCatalog size={24} />
                        </div>

                        <span className="text-[10px] leading-[14px] tracking-[0.02px]">
                            Каталог
                        </span>
                    </Link>

                    <Link
                        href="/cart"
                        className="flex flex-col items-center justify-center cursor-pointer rounded-md hover:bg-gray-200 px-3 py-1"
                    >
                        <div className="relative inline-block">
                            <div className="w-[34px] h-[34px] flex justify-center items-center">
                                <PiShoppingCartSimpleDuotone size={24} />
                            </div>
                            {(countItems ?? 0) > 0 && (
                                <Badge
                                    content={countItems}
                                    innerClass="!bg-error"
                                    className="absolute -top-[1px]
                    -right-[1px]
                    w-4 h-4 
                    flex items-center justify-center 
                    text-[10px]
                    px-[4px] py-[4px]
                    rounded-full"
                                />
                            )}
                        </div>

                        <span className="text-[10px] leading-[14px] tracking-[0.02px] text-center">
                            Корзина
                        </span>
                    </Link>
{isCatalogPage &&  (
                    <div className="flex flex-col items-center justify-center cursor-pointer rounded-md hover:bg-gray-200 px-3 py-1">
                        <DrawerFilter />
                    </div>
)}


                </div>
            </StickyFooter>
        </>
    )
}
